import { useState} from "react";
import { SportsMapInv } from "./SportMap";
import { Link, useParams } from "react-router-dom";
import { getDiv } from "../hooks/useTeam";
import { Spinner } from "flowbite-react";

export const GetAllDivision = () => {
  const { data: divisionData, isLoading, isError } = getDiv();
  document.title = "NILO - Divisions";
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !divisionData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch Division List</p>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <div className="max-w-7xl sm:columns-4 sm:gap-16">
        {divisionData.map((key) => {
          return (
            <div key={key} className="px-8 py-4">
              <Link to={`/Division/${key}`}>{key}</Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const GetDivision = () => {
  const id = useParams().id;
  const { data: divisionData, isLoading, isError } = getDiv(id);
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !divisionData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch Division List</p>
      </div>
    );
  }

  document.title = "NILO - " + id + " Teams";
  return (
    <div className="flex sm:justify-around">
      <div className="w-full sm:max-w-7xl sm:flex sm:flex-col">
        {Object.entries(divisionData).map(([sportName, sport]) => {
          return (
            <div className="my-2 sm:my-10" key={sportName}>
              <div className="font-bold">{SportsMapInv[sportName]}</div>
              <hr className="h-1" />
              <div className="max-w-7xl sm:my-4 py-auto sm:columns-4 sm:gap-16">
                {sport.map((team) => {
                  return (
                    <div
                      key={team.nilo_id}
                      className="py-3 break-inside-avoid-column"
                    >
                      <Link to={`/Team/${team.nilo_id}`}>{team.name}</Link>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
